/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./itemSelector.vue?vue&type=template&id=424da594&scoped=true"
import script from "./itemSelector.vue?vue&type=script&lang=js"
export * from "./itemSelector.vue?vue&type=script&lang=js"
import style0 from "./itemSelector.vue?vue&type=style&index=0&id=424da594&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424da594",
  null
  
)

export default component.exports